module.exports = __webpack_public_path__ + "assets/f3e375f299776bd5443923a6188cb570.svg";